// import React from "react";

// export const DataComp = React.memo(
//   ({
//     src,
//     alt,
//     ee,
//     h2Title,
//     p_Desc,
//     post_author,
//     post_date,
//     post_location,
//     withZoom,
//     loading,
//     srcSet
//   }) => {
//     const options = {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     };

//     console.log("post_date :",post_date);
//     console.log("post_location :",post_location);
//     console.log("p_Desc :",p_Desc);
//     // console.log("p_Desc :",p_Desc);
//     return (
//       <div
//         className={ee}
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           marginTop: "15px",
//         }}
//       >
//         <figure className={withZoom ? "image-container" : ""}>
//           <img
//             src={src}
//             srcSet={srcSet}
//             className="homeImg"
//             alt={alt}
//             width="500"
//             height="500"
         
//             loading={loading}
//           />
//         </figure>
//         <div>
//           <h2 className="fw-bold h4  hoverHead line-clamp">{h2Title}</h2>
//           <p style={{ fontSize: "12px" }}>
//             By <span className="fw-bold">{post_author}</span> |{" "}
//             {new Date(post_date).toLocaleDateString(undefined, options)}
//           </p>
//           <p className="just-text line-clamp mt-1" style={{ fontSize: "12px" }}>
//             {p_Desc}
//           </p>
//         </div>
//       </div>
//     );
//   }
// );

// --------------------

import React from "react";

export const DataComp = React.memo(
  ({
    src,
    alt,
    ee,
    h2Title,
    p_Desc,
    post_author,
    post_date,
    post_location,
    withZoom,
    loading,
    srcSet,
    imgClassName,
    imgClassName1
  }) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    // Extract children from post_location
    let locationText = "";
    let dateText = "";

    if (
      post_location &&
      post_location.props &&
      Array.isArray(post_location.props.children)
    ) {
      const children = post_location.props.children;
      if (children.length >= 2) {
        const [locationEl, dateEl] = children;
        locationText = locationEl.props?.children || "";
        dateText = dateEl.props?.children || "";
      }
    }

    return (
      <div
        className={ee}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "15px",
        }}
      >
        <figure className={withZoom ? "image-container" : ""}>
          <img
            src={src}
            srcSet={srcSet}
            // className="eventImg"
            alt={alt}
            width="100%"
            loading={loading}
            className={`eventImg ${imgClassName || ""} ${imgClassName1}`}
          />
        </figure>
        <div>
          <h2 className="fw-bold h4 hoverHead line-clamp">{h2Title}</h2>
          {(locationText?(
            <p style={{ fontSize: "12px" }}>
             <span className="fw-bold">{locationText ?locationText:post_author}</span> {dateText?dateText:post_date}
          </p>
          ):<p style={{ fontSize: "12px" }}>
                      By <span className="fw-bold">{post_author}</span> |{" "}
                     {new Date(post_date).toLocaleDateString(undefined, options)}
                     </p>)}
          
          <p className="just-text line-clamp mt-1" style={{ fontSize: "12px" }}>
            {p_Desc}
          </p>
        </div>
      </div>
    );
  }
);
